<template>
  <div style="padding: 40px 60px;">
    <div>
      <div class="changement-abonnement-alias-header">
        {{ ressourceHeaderLabel }}
      </div>

      <div class="offre-selectionner">
        <div class="offre-content">
          <div class="offre-badge">
            <span>
              {{ nouvelleOffreSelectionner.id == 1 ? 'FREE' : '★'.repeat(nouvelleOffreSelectionner.id - 1) }}
            </span>
            <span>{{ formattedTitle(nouvelleOffreSelectionner) }}</span>
          </div>
          <span>{{ nouvelleOffreSelectionner.mensuel }}</span>
          <span>€/mois </span>
          <!--          <a :href="nouvelleOffreSelectionner.url" class="subscription-link offre-link" target="_blank" rel="noopener">
                      En savoir plus sur l'offre {{ formattedTitle(nouvelleOffreSelectionner) }}
                    </a>-->
        </div>
      </div>

      <etablissement-select v-if="severalEtabs"
                            :theme="theme"
                            :showMissing="showMissing"
                            v-model:value=etablissementId
                            :moduleId=moduleId
                            libelle="'Etablissement facturé'"
                            newLabel=''
                            selectText=""
                            @status=statusEtablissementId
                            :requiredAttributs="requiredAttributs"
                            :autoSelect=true
                            :ressource=ressourceEtablissementSelect
                            :filters=etablissementIdFilter
                            :required="true"
                            :readOnly="false"
                            :sectionName="sectionName">
      </etablissement-select>

      <payment-means-summary v-model:value=aboMeansId
                             :ressource="ressourceAbo"
                             :toggleReset=resetPaymentMeansSummary
                             :owner="owner"
                             :filters="aboMeansIdFilter"
                             class="subscription-payment"
                             :readOnly="offreFree"
                             @update:value="setPaymentMeans">
      </payment-means-summary>

      <div class="date-renouvellement">
        <div class="edit-field-label">{{ labelDate }}</div>
        <v-text-field class="subscription-renew-date"
                      variant="plain"
                      :value="dateDebut"
                      readonly />
      </div>

      <div class="info-abo">
        {{ infoChangement }}
      </div>

      <div class="d-flex justify-content-center pt-3" style="gap: 10px; padding-bottom: 20px;">
        <div style="width: 50%;">
          <loader-button class="ms-2"
                         type="submit"
                         :label="closeLabel"
                         :outlined="true"
                         :full-width="true"
                         @callback="retour">
          </loader-button>
        </div>
        <div style="width: 50%;">
          <loader-button class="ms-2"
                         type="submit"
                         :label="aboLabel"
                         :disabled="!canSubscribe"
                         :loading=loading
                         :full-width="true"
                         @callback="apply">
          </loader-button>
        </div>
      </div>

      <div class="note">
        En souscrivant, vous acceptez nos
        <a @click="showCGU()" class="cgu-underline">conditions générales d’utilisation</a>.
      </div>

    </div>
  </div>
</template>

<script lang="ts">
  import {
    AppControls,
    FwkButtons,
    FwkSections,
    RessourceAppControl,
    RessourceFwkButton,
    RessourceFwkSection
  } from '@/ressources/globalRessources';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import {storePaymentMeans, storeSubscription, storeSubscriptionType} from '@/generated/stores';
  import SubscriptionType, { SubscriptionRequired } from '@/generated/classes/SubscriptionType';
  import PaymentMeansSummary from '@/extend/controls/paymentMeans/PaymentMeansSummary';
  import PaymentMeans, { PaymentMeansTypes } from '@/generated/classes/PaymentMeans';
  import DialogHubManager from "@/framework/dialog/helpers/DialogHubManager";
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import Owner from '@/generated/classes/Owner';
  import Subscription from '@/generated/classes/Subscription';
  import { defineComponent, type PropType } from "vue";
  import { storeEtablissement } from '@/generated/stores';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import EtablissementSelect from '@/extend/controls/etablissement/EtablissementSelect';
  import { DateFormat } from '@/framework/base/helpers/DateFormat';
  import User from "@/generated/classes/User";
  import HubServices from "@/generated/hub/HubServices.ts";
  import type { SubscriptionCompletion } from '@/custom/helpers/subscriptionDeclaration';

  export default defineComponent({
    components: {
      EtablissementSelect,
      PaymentMeansSummary,
      LoaderButton,
    },
    props: {
      hideTitle: {
        type: Boolean
      },
      owner: {
        type: Object as PropType<Owner>,
        required: true
      },
      subscriptionRequired: {
        type: Object as PropType<SubscriptionRequired>,
        required: true
      },
      subscriptionTypeSelected: {
        type: Number,
        default: 0
      },
      nouvelleOffreSelectionner: {
        type: Object as PropType<SubscriptionType>,
        required: true
      },
    },
    created() {
      DialogHubManager.waitAnswer('subscribe', this.finalise);
      const subscription = storeSubscription.listSubscription.find(a => a.ownerId == this.owner.objId && a.ownerType == this.owner.objType);
      if (subscription) {
        this.initialSubscriptionTypeId = subscription.subscriptionTypeId;
        this.etablissementId = subscription.ownerId;
        this.aboMeansId = subscription.aboMeansId;
      } else {
        this.etablissementId = this.owner.objId;
      }
      if (this.aboMeansId > 0) {
        this.setPaymentMeans(this.aboMeansId);
      }
    },
    mounted() {
      DialogHubManager.waitAnswer('createPaymentMeans', this.createPaymentMeans);
      HubServices.connection.on('PaymentMeansUpdated', this.updatePaymentMeans);
    },
    data() {
      return {
        loading: false,
        meansPrelevement: 1,
        toggleReset: false,
        labelOffre: 'Offre selectionnée',
        labelDate: 'Date de souscription',
        aboMeansId: 0,
        etablissementId: 0,
        initialSubscriptionTypeId: 0,
        changeSuccess: false,
        mandatSigned: true,
        paymentMeansTypeId: 0
      };
    },
    computed: {
      ressourceHeaderLabel() {
        if (this.subscriptionTypeSelected > 0 && this.initialSubscriptionTypeId > 0) {
          return 'Changement d\'abonnement pour ' + this.etablissementAlias;
        }
        return 'Abonnement pour ' + this.etablissementAlias;
      },
      ressourceOffer() {
        return RessourceAppControl(AppControls.SELECT_OFFER);
      },
      ressourceAbo() {
        return RessourceAppControl(AppControls.PAYMENT_MEANS);
      },
      ressourceEtablissementSelect() {
        return RessourceAppControl(AppControls.BILLED_ETAB);
      },
      etablissementAlias() {
        return storeEtablissement.getEtablissement(this.owner.objId).alias;
      },
      aboLabel() {
        if (!this.mandatSigned && this.paymentMeansTypeId > 0) {
          return "Signer le mandat";
        }
        if (this.nouvelleOffreSelectionner.id == this.subscription.subscriptionTypeId && this.subscription.dateResiliation == null) {
          return RessourceFwkButton(FwkButtons.MODIFIER).label;
        } else {
          return RessourceFwkButton(FwkButtons.SOUSCRIRE).label;
        }
      },
      infoChangement() {
        if (this.nouvelleOffreSelectionner.id != this.subscription.subscriptionTypeId) {
          if (this.offreFree) {
            return 'Vous avez choisi l\'offre ' + this.nouvelleOffreSelectionner.label + ' sans engagement. Le changement d’offre est possible à tout moment.';
          } else {
            if (this.mandatSigned) {
              return 'Vous allez souscrire un nouvel abonnement avec un engagement de 12 mois. Le changement d’offre est possible à tout moment.';
            } else {
              return "Pour régler votre nouvel abonnement, veuillez générer et signer le mandat de prélèvement unique.";
            }
          }
        } else {
          return 'Vous êtes abonné à l\'offre ' + this.nouvelleOffreSelectionner.label + ' jusqu\'au ' + this.dateFin + '. Vous pouvez modifier votre moyen de paiement pour l\'échéance du ' + this.dateEcheance + '.'
        }
      },
      closeLabel() {
        return 'Retour';
      },
      errorTxt() {
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },
      subscription(): Subscription {
        let res = new Subscription();
        const subscription = storeSubscription.listSubscription.find(a => a.ownerId == this.owner.objId && a.ownerType == this.owner.objType);
        if (subscription) {
          res = subscription;
        }
        return res;
      },
      canSubscribe(): boolean {
        const selectedType = storeSubscriptionType.getSubscriptionType(this.nouvelleOffreSelectionner.id);
        if (this.nouvelleOffreSelectionner.id == 0 || (this.paymentMeansTypeId <= 0 && selectedType.mensuel > 0)) {
          return false;
        } else {
          return ((this.nouvelleOffreSelectionner.id != this.subscription.subscriptionTypeId ||
            this.subscription.dateResiliation != null ||
            this.subscription.ownerId != this.etablissementId ||
            this.aboMeansId != this.subscription.aboMeansId) &&
            (this.aboMeansId > 0 && this.nouvelleOffreSelectionner.id > 0 ||
              this.nouvelleOffreSelectionner.id == this.subscriptionRequired.terminateId ||
              selectedType.mensuel == 0));
        }
      },
      aboMeansIdFilter(): ColumnFilter[] {
        const etablissement = storeEtablissement.getEtablissement(this.owner.objId);
        const res: ColumnFilter[] = [];
        {
          const filter = new ColumnFilter();
          filter.name = "type";
          filter.sortAscending = true;
          {
            const prelevement = new ListChoix();
            prelevement.value = PaymentMeansTypes.RIB;
            filter.filters.push(prelevement);
          }
          res.push(filter);
        }
        {
          const filter = new ColumnFilter();
          filter.name = "ownerType";
          filter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = ObjTypes.CLIENT;
          filter.filters.push(choix);
          res.push(filter);
        }
        {
          const filter = new ColumnFilter();
          filter.name = "ownerId";
          filter.staticFilter = true;
          {
            const choix = new ListChoix();
            choix.value = etablissement.clientId;
            filter.filters.push(choix);
          }
          {
            const choix = new ListChoix();
            choix.value = 0;
            filter.filters.push(choix);
          }
          res.push(filter);
        }
        return res;
      },
      resetPaymentMeansSummary: {
        get(): boolean {
          return this.toggleReset
        },
        set(value: boolean) {
          this.toggleReset = value;
        }
      },
      severalEtabs(): boolean {
        const etablissement = storeEtablissement.getEtablissement(this.owner.objId);
        const etabs = storeEtablissement.listEtablissement.filter(a => a.societeId == etablissement.societeId);
        return etabs.length > 1;
      },
      etablissementIdFilter(): ColumnFilter[] {
        const etablissement = storeEtablissement.getEtablissement(this.owner.objId);
        const res: ColumnFilter[] = [];
        const filter = new ColumnFilter();
        filter.name = "societeId";
        filter.sortAscending = true;
        {
          const choix = new ListChoix();
          choix.value = etablissement.societeId;
          filter.filters.push(choix);
        }
        res.push(filter);
        return res;
      },
      dateDebut(): string {
        const debut = this.nouvelleOffreSelectionner.id != this.subscription.subscriptionTypeId ? new Date() : this.subscription.dateDebut;
        return DateFormat.getDateLabel(debut);
      },
      dateEcheance(): string {
        const echeance = new Date(this.nouvelleOffreSelectionner.id != this.subscription.subscriptionTypeId ? new Date() : this.subscription.dateDebut);
        echeance.setMonth(echeance.getMonth() + 1);
        return DateFormat.getDateLabel(echeance);
      },
      dateFin(): string {
        const fin = new Date(this.nouvelleOffreSelectionner.id != this.subscription.subscriptionTypeId ? new Date() : this.subscription.dateDebut);
        fin.setFullYear(fin.getFullYear() + 1);
        return DateFormat.getDateLabel(fin);
      },
      offreFree(): boolean {
        return this.nouvelleOffreSelectionner.mensuel == 0;
      }
    },
    methods: {
      showCGU() {
        User.showCgu();
      },
      updatePaymentMeans(obj: unknown) {
        const wasMandatSigned = this.mandatSigned;
        this.toggleReset = !this.toggleReset;
        this.setPaymentMeans(this.aboMeansId);
        if (!wasMandatSigned && this.mandatSigned) {
          this.loading = true;
        }
      },
      createPaymentMeans(obj: unknown) {
        const paymentMeans = obj as PaymentMeans;
        this.subscription.aboMeansId = paymentMeans.id;
        this.aboMeansId = paymentMeans.id;
        this.toggleReset = !this.toggleReset;
      },
      setPaymentMeans(value: number) {
        const paymentMeans = storePaymentMeans.getPaymentMeans(value);
        this.mandatSigned = paymentMeans.mandatB2c.signedAt != null;
        this.aboMeansId = value;
        this.paymentMeansTypeId = paymentMeans.typeId;
      },
      formattedTitle(option: SubscriptionType) {
        return option.label.charAt(0).toUpperCase() + option.label.slice(1).toLowerCase()
      },
      retour() {
        this.$emit('goToSelection', this.changeSuccess);
      },
      apply() {
        const subscription = new Subscription();
        subscription.id = this.subscription.id;
        subscription.subscriptionTypeId = this.nouvelleOffreSelectionner.id;
        subscription.owner = this.owner;
        subscription.aboMeansId = this.aboMeansId;
        this.loading = true;
        SubscriptionType.subscribe(subscription).then((res: Subscription) => {
          if (!this.changeSuccess && res && res.subscriptionTypeId != this.initialSubscriptionTypeId && res.subscriptionTypeId > 0) {
            this.$emit('goToSelection', this.changeSuccess);
          }
          this.loading = false;
        }).catch(() => {
          //this.loading = false;
        });
      },
      finalise(completion: SubscriptionCompletion): void {
        this.loading = false;
        if (completion.completed && completion.subscriptionType.id > 0 &&
            completion.subscriptionType.id != this.initialSubscriptionTypeId) {
          this.changeSuccess = true;
          this.$emit('goToConfirmation', completion.declarationInformation);
        } else {
          this.$emit('goToSelection', this.changeSuccess);
        }
      }
    }
  })

</script>

<style>
  .info-abo {
    color: #09292A;
    font-size: 17.5px;
    font-weight: 400;
  }

  .cgu-underline {
    text-decoration: underline;
    color: #135253;
    cursor: pointer;
  }

  .note {
    font-size: 14px;
    font-weight: 400;
    color: #135253;
  }

  .offre-content {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding-bottom: 4px;
    border-bottom: 1px solid #ACEBEC;
    font-size: 14px;
    align-items: center;
  }

  .offre-link {
    text-decoration: none;
    font-size: 11px;
    font-weight: 500;
  }

  .offre-badge {
    background-color: #F1F3F4;
    padding: 6px 12px;
    border-radius: 4px;
    display: inline-flex;
    gap: 4px;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
  }

  .subscription-payment .v-field__input {
    padding-inline: 2px;
  }

  .subscription-renew-date .v-field__input {
    padding-inline: 2px;
    font-size: 14px;
    font-weight: 400;
  }

  .changement-abonnement-alias-header {
    font-weight: 500;
    font-size: 22px;
    padding-bottom: 32px;
  }
</style>
